var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"NoData"},[_vm._m(0),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('common.nodata')))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"imgWrap"},[_c('img',{attrs:{"src":"/img/empty.png"}})])
}]

export { render, staticRenderFns }